<template>
  <div>
<!--    <h4>Отзывы</h4>
    <div class="input">
      <input :class="{error: errors.first('comment') && validate}" v-validate="'required'" type="text" autocomplete="off" name="comment" v-model="comment" placeholder="Написать отзыв...">
      <div class="rate">
        <div class="rating-area">
          <input type="radio"  v-validate="'required'" data-vv-as=" " v-model="rate" id="star-1" name="rating" value="5">
          <label for="star-1" title="Оценка «1»"></label>
          <input type="radio" v-validate="'required'" data-vv-as=" " v-model="rate" id="star-2" name="rating" value="4">
          <label for="star-2" title="Оценка «2»"></label>
          <input type="radio" v-validate="'required'" data-vv-as=" " v-model="rate" id="star-3" name="rating" value="3">
          <label for="star-3" title="Оценка «3»"></label>
          <input type="radio" v-validate="'required'" data-vv-as=" " v-model="rate" id="star-4" name="rating" value="2">
          <label for="star-4" title="Оценка «4»"></label>
          <input type="radio" v-validate="'required'" data-vv-as=" " v-model="rate" id="star-5" name="rating" value="1">
          <label for="star-5" title="Оценка «5»"></label>
        </div>
        <div class="error-block" v-if="errors.first('rating') && validate"></div>
      </div>
      <button @click="send()">Отправить</button>
    </div>-->
    <loading-container :loading="loading">
      <div class="reviews-container">
        <div class="review-column">
          <div v-for="reviewsItem in reviews" :key="'review-' + reviewsItem.id">
            <div class="review-block">
              <div class="review-header">
                <div class="review-avatar-block">
                  <img class="review-avatar" :src="getAvatar(reviewsItem.photo)">
                </div>
                <div class="review-name-block">
                  <span>
                    {{reviewsItem.name}} {{reviewsItem.surname}}
                  </span>

                </div>
                <div class="review-header-right-block">
                  <div class="review-date-block">
                    {{reviewsItem.time}}
                  </div>

                  <div class="review-rate-block" v-if="reviewsItem.rate > 0">
                    <div class="rate">
                      <img style="width: 18px;" src="../../assets/icons/star-orange.svg" v-for="a in reviewsItem.rate" :key="'r'+a"/>
                      <img style="width: 18px;" src="../../assets/icons/star-grey.svg" v-for="i in 5 - reviewsItem.rate" :key="'rate'+i"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="review-message">
                {{reviewsItem.review}}
              </div>
              <div class="review-footer">
                <span v-if="reviewsItem.benefits" class="review-green-title">Достоинства</span><br>
                <span v-if="reviewsItem.benefits" class="review-footer-text">
                  {{reviewsItem.benefits}}
                </span><br>
                <span v-if="reviewsItem.shortcomings" class="review-green-title">Недостатки</span><br>
                <span v-if="reviewsItem.shortcomings" class="review-footer-text">
                  {{reviewsItem.shortcomings}}
                </span>
                <div class="photo-container">
                  <div class="review-photo-block" v-for="(image, idx) in reviewsItem.photos" :key="'image-' + idx">
                    <img :src="image" alt="" class="photo">
                  </div>
                </div>
              </div>
              <div class="review-rate-vote">
                <div class="vote-title">
                  Вам помог этот отзыв?
                </div>
                <div class="vote-btn-block">
                  <div class="vote-btn" @click="reviewAssistance(1, reviewsItem.id)">Да <span style="color: #2CB181;">{{reviewsItem.helped_count > 0 ? reviewsItem.helped_count : ''}}</span></div>
                  <div class="vote-btn" @click="reviewAssistance(2, reviewsItem.id)">Нет <span style="color: #2CB181;">{{reviewsItem.did_not_help_count > 0 ? reviewsItem.did_not_help_count : ''}}</span></div>
                </div>
              </div>
              <div class="reply" @click="$refs.review.open(item.id, reviewsItem.id, reviewsItem.user_id)">
                Ответить
              </div>
            </div>

            <div v-if="reviewsItem.answers.length > 0">
              <div class="review-block ml-20" v-for="answer in reviewsItem.answers" :key="'answer' + answer.id">
                <div class="review-header">
                  <div class="review-avatar-block">
                    <img class="review-avatar" :src="getAvatar(answer.user.image)">
                  </div>
                  <div class="review-name-block">
                    <span>
                      {{answer.user.name}} {{answer.user.surname}}
                    </span>
                    <br>
                    <span class="answer-user">
                      в ответ {{answer.answer_user.name}} {{answer.answer_user.surname}}
                    </span>
                  </div>
                  <div class="review-header-right-block">
                    <div class="review-date-block">
                      {{answer.time}}
                    </div>
                  </div>
                </div>
                <div class="review-message">
                  {{answer.review}}
                  <div class="photo-container">
                    <div class="review-photo-block" v-for="(image, idx) in reviewsItem.photos" :key="'image-' + idx">
                      <img :src="image" alt="" class="photo">
                    </div>
                  </div>
                </div>
                <div class="review-rate-vote">
                  <div class="vote-title">
                    Вам помог этот отзыв?
                  </div>
                  <div class="vote-btn-block">
                    <div class="vote-btn" @click="reviewAssistance(1, answer.id)">Да <span style="color: #2CB181;">{{answer.helped_count > 0 ? answer.helped_count : ''}}</span></div>
                    <div class="vote-btn" @click="reviewAssistance(2, answer.id)">Нет <span style="color: #2CB181;">{{answer.did_not_help_count > 0 ? answer.did_not_help_count : ''}}</span></div>
                  </div>
                </div>
                <div class="reply" @click="$refs.review.open(item.id, reviewsItem.id, answer.user_id)">
                  Ответить
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rating-column">
          <div class="result-rate-block">
            <div class="rate">
              <img src="../../assets/icons/star-orange.svg" v-for="a in rate_star" :key="'r'+a"/>
              <img src="../../assets/icons/star-grey.svg" v-for="i in 5 - rate_star" :key="'rate'+i"/>
            </div>
            <div class="rate-number">
              {{rate}}/5
            </div>
            <div style="border: 1px solid #00A9E0; margin-top: 20px; margin-bottom: 20px;"></div>
            <div class="rate-info-container">
              <div class="rate-info-first"> 5 звезд</div>
              <div class="rate-info-second">
                <img src="../../assets/icons/full-line.svg" style="width: 100%; height: 5px;"/>
                <img class="active-line" src="../../assets/icons/progress-line.svg" :style="{width: getPercent(rate_count['5'])}" style=" height: 5px;"/>
              </div>
              <div class="rate-info-third">
                {{rate_count['5']}}
              </div>
            </div>
            <div class="rate-info-container">
              <div class="rate-info-first"> 4 звезды</div>
              <div class="rate-info-second">
                <img src="../../assets/icons/full-line.svg" style="width: 100%; height: 5px;"/>
                <img class="active-line" src="../../assets/icons/progress-line.svg" :style="{width: getPercent(rate_count['4'])}" style="height: 5px;"/>
              </div>
              <div class="rate-info-third">
                {{rate_count['4']}}
              </div>
            </div>
            <div class="rate-info-container">
              <div class="rate-info-first"> 3 звезды</div>
              <div class="rate-info-second">
                <img src="../../assets/icons/full-line.svg" style="width: 100%; height: 5px;"/>
                <img class="active-line" src="../../assets/icons/progress-line.svg" :style="{width: getPercent(rate_count['3'])}" style="height: 5px;"/>
              </div>
              <div class="rate-info-third">
                {{rate_count['3']}}
              </div>
            </div>
            <div class="rate-info-container">
              <div class="rate-info-first"> 2 звезды</div>
              <div class="rate-info-second">
                <img src="../../assets/icons/full-line.svg" style="width: 100%; height: 5px;"/>
                <img class="active-line" src="../../assets/icons/progress-line.svg" :style="{width: getPercent(rate_count['2'])}" style=" height: 5px;"/>
              </div>
              <div class="rate-info-third">
                {{rate_count['2']}}
              </div>
              <div class="rate-info-container">
                <div class="rate-info-first"> 1 звезда</div>
                <div class="rate-info-second">
                  <img src="../../assets/icons/full-line.svg" style="width: 100%; height: 5px;"/>
                  <img class="active-line" src="../../assets/icons/progress-line.svg" :style="{width: getPercent(rate_count['1'])}" style=" height: 5px;"/>
                </div>
                <div class="rate-info-third">
                  {{rate_count['1']}}
                </div>
              </div>

              <button class="big-btn" @click="$refs.review.open(item.id)">
                Написать отзыв
              </button>
              <span v-if="count_reviews > 0" class="review-count">
                По оценке {{getCountTitle()}}
              </span>
            </div>
          </div>
        </div>
      </div>
<!--    <div class="mcard" :key="idx" v-for="(reviewsItem, idx) in reviews">
        <div class="mcard__top">
          <div class="title">
            <img :src="reviewsItem.photo">
            <div>{{reviewsItem.name}} {{reviewsItem.surname}}</div>
          </div>
          <div class="info">
            <div class="rate">
              <img src="../../assets/icons/star-orange.svg" v-for="a in reviewsItem.rate" :key="'r'+a"/>
              <img src="../../assets/icons/star-grey.svg" v-for="i in 5 - reviewsItem.rate" :key="'rate'+i"/>
            </div>
            <div class="date">{{reviewsItem.time}}</div>
          </div>
        </div>
        <div class="mcard__text">
          {{reviewsItem.review}}
        </div>-->
        <!--<div class="mcard__reply" :key="idx" v-for="(replyItems, idx) in reviewsItem.reply">
          <div class="mcard__reply-top">
            <div class="title">
              <img :src="replyItems.image">
              <div>{{replyItems.fullname}}</div>
            </div>
            <div class="info">

              <div class="date">{{replyItems.date}}</div>
            </div>
          </div>
          <div class="mcard__text">
            {{replyItems.review}}
          </div>
        </div>-->
        <!--<a href="#">Ответить</a>-->
<!--    </div>-->

      <product-review-modal ref="review" @send="send($event)"/>
    </loading-container>
  </div>
</template>

<script>
  import LoadingContainer from "@/components/loading-container";
  import ProductReviewModal from "@/components/modals/product-review-modal";

    export default {
        name: "item-reviews",
        components: {LoadingContainer, ProductReviewModal},
        data: ()=>({
            rate: 0,
            rate_star: 0,
            rate_count: [],
            count_reviews: 0,
            loading: false,
            validate: true,
            reviews: [
                /*{
                    image: require ( '../../assets/img/main/avatar1.png' ),
                    fullname: 'Светлана Войкова',
                    rate:'4',
                    date: '23 апреля 2020',
                    review: 'Замечательный магазин. Уже не однократно закупаю монеты для своей коллекции. Все монеты в хорошем состоянии. Удобный и понятный интерфейс сайта. Фото монет соответствуют тем что заказывал. Заказ собирают быстро. Очень благоприятная обстановка в офисе',
                },
                {
                    image: require ( '../../assets/img/main/avatar2.png' ),
                    fullname: 'Артем Смирнов',
                    rate:'1',
                    date: '23 апреля 2020',
                    review: 'Не понравился товар, не то качество.. ',
                    reply: [
                        {
                            image: require ( '../../assets/img/main/avatar3.png' ),
                            fullname: 'Михаил Суренко',
                            date: '23 апреля 2020',
                            review: 'Расскажите что именно вам не понравилось? ',
                        },
                        {
                            image: require ( '../../assets/img/main/avatar2.png' ),
                            fullname: 'Артем Смирнов',
                            date: '23 апреля 2020',
                            review: 'Не Удобный и Не понятный интерфейс сайта. Фото товара Не соответствуют тем что заказывал. Заказ собирают долго.',
                        }
                    ],
                },*/

            ]
        }),
        props: {
          item: null
        },
        mounted() {
          this.getReviews();
        },
        methods: {
          getCountTitle() {
            let n = this.count_reviews;
            return `${n} покупател${(n%100<11 || n%100>19)?((n%10!=1)?((n%10>1 && n%10<5)?'ей':'ей'):'я'):''}`;
          },
          getReviews() {
            if (localStorage.getItem('token')) {
              this.$http.post('/get-product-reviews', {
                token: localStorage.getItem('token'),
                product: this.item.id
              }).then(({data}) => {
                if (data.reviews) {
                  this.reviews = data.reviews;
                  this.rate = data.rate;
                  this.$emit('setRate', {'rate': Math.floor(this.rate), 'count': data.count_reviews});
                  this.rate_count = data.rate_count;
                  this.count_reviews = data.count_reviews;
                  this.rate_star = Math.floor(this.rate);
                }
              })
              .catch((error) => {
                  console.log(error)
              })
              .finally(()=> {this.loading = false;})
            }
          },
          getPercent(val) {
            if(this.count_reviews > 0) {
              let percent = (val / this.count_reviews) * 100;

              return percent + '%';
            }
            return '0%';
          },
          getAvatar(avatar){
            if(avatar == 'https://api.superbaer24.ru/storage/') return require('@/assets/icons/user-nav.svg')
            else return avatar
          },
          reviewAssistance(val, review_id) {
            if (localStorage.getItem('token')) {
              this.$http.post('/product-review-assistance', {
                token: localStorage.getItem('token'),
                helped: val,
                review_id: review_id
              }).then(({data}) => {
                if (data.success) {
                  this.$toast.success('Данные успешно сохранены!');
                  this.reviews = data.reviews;
                }
              }).catch((error) => {
                console.log(error)
              })
            }
          },
          send(val) {
            this.rate = val.rate;
            this.rate_count = val.rate_count;
            this.count_reviews = val.count_reviews;
            this.rate_star = Math.floor(this.rate);
            this.reviews = val.reviews;
          },
         /* send() {
            this.validate = true;
            this.$validator.validateAll().then(success => {
              if (success) {
                this.$http.post('/create-product-review', {
                  token: localStorage.getItem('token'),
                  rate: this.rate,
                  review: this.comment,
                  product_id: this.item.id
                }).then(({data}) => {
                  if (data.success) {
                    this.getReviews();
                    this.$toast.success('Отзыв успешно сохранен!');
                    this.rate = '';
                    this.comment = '';
                    this.validate = false;
                  }
                })
                .catch((error) => {
                  console.log(error)
                  this.$toast.error('Ошибка!');
                })
              }
          })
          }*/
        }
    }
</script>

<style scoped lang="scss">


  .review-photo-block:nth-child(6n), .review-photo-block:first-child {
    margin-left: 0px;
  }

  .review-photo-block {
    position: relative;
    width: 18%;
    display: inline-block;
    margin-left: 2.5%;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .photo {
    width: 100%;
    border-radius: 10%;
  }

  .photo-container {
    width: 100%;
  }

  .answer-user {
    font-size: 16px;
    line-height: 19px;
    color: #2CB181;
  }

  .reply {
    position: absolute;
    bottom: -20px;
    font-size: 14px;
    line-height: 18px;
    color: #767676;
    cursor: pointer;
  }

  .review-count {
    font-size: 12px;
    line-height: 18px;
    color: #535353;
  }

  .big-btn{
    width: 100%;
    height: 36px;
    padding: 0px 10px;
    border: unset;
    outline: unset;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: white;
    background-color: #2CB181;
    border-radius: 50px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .rate-info-container {
    margin-top: 10px;
  }

  .reviews-container {
    width: 90%;
  }

  .active-line {
    position: absolute;
    top: 10px;
    left: 0px;
  }

  .rate-info-first {
    display: inline-block;
    font-size: 12px;
    color: #535353;
    width: 22%;
  }

  .rate-info-second {
    display: inline-block;
    position: relative;
    width: 68%;
  }

  .rate-info-third {
    display: inline-block;
    width:  10%;
    text-align: right;
    font-size: 14px;
  }

  .review-column {
    width: 64%;
    margin-right: 2%;
    display: inline-block;
  }

  .rating-column {
    width: 34%;
    display: inline-block;
    background: rgba(44, 177, 129, 0.1);
    border-radius: 10px;
    vertical-align: top;
    padding: 20px 20px;
    position: relative;
  }

  .rate-number {
    font-size: 24px;
    position: absolute;
    top: 15px;
    right: 20px;
  }

  .review-block {
    border: 1px solid #DFDFDF;
    box-sizing: border-box;
    border-radius: 6px;
    margin-bottom: 30px;
    position: relative;
  }

  .result-rate-block .rate {
    width: 192px;
  }

  .result-rate-block .rate img {
    width: 26px;
    margin: 0px 6px;
  }

  .ml-20 {
    margin-left: 20px;
  }

  .review-header {
    border-bottom: 1px solid #DFDFDF;
    padding: 10px 20px;
    position: relative;
  }

  .review-avatar {
    height: 40px;
    width: 40px;
    border: 1px solid #2CB181;
    border-radius: 50%;
  }

  .review-avatar-block {
    display: inline-block;
    margin-right: 10px;
    width: 40px;
  }

  .review-avatar-block img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .review-name-block {
    display: inline-block;
    margin-right: 10px;
    max-width: 57%;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
    vertical-align: top;
    padding-top: 10px;
  }

  .review-date-block {
    width: 90px;
    display: inline-block;
    margin-top: 9px;
    vertical-align: middle;
  }

  .review-header-right-block {
    position: absolute;
    top: 0px;
    right: 20px;
  }

  .review-rate-block {
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
  }

  .review-message {
    padding: 10px;
  }

  .review-footer {
    padding: 10px;
    border-top: 1px solid #DFDFDF;

  }

  .review-green-title {
    font-size: 16px;
    line-height: 18px;
    color: #2CB181;
    font-weight: 500;
  }

  .review-footer-text {
    font-size: 14px;
    line-height: 18px;
    color: #333333;
    margin-bottom: 10px;
    display: inline-block;
  }

  .review-rate-vote {
    padding: 10px;
    border-top: 1px solid #DFDFDF;
    position: relative;
  }

  .vote-title {
    font-size: 14px;
    line-height: 18px;
    color: #767676;
  }

  .vote-btn {
    background: #EBEBEB;
    border-radius: 15px;
    padding: 2px 18px;
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
  }

  .vote-btn-block {
    position: absolute;
    top: 5px;
    right: 20px;
  }

  .error {
    border: 1px solid red !important;
  }

  .error-block {
    position: absolute;
    width: 100%;
    border: 1px solid red;
    height: 40px;
    border-radius: 4px;
    z-index: 1;
  }
  .rate{
    display: flex;
    align-items: center;
    justify-content: center;
   /* width: 20%;*/
    position: relative;

    .rating-area {
      overflow: hidden;
      margin-bottom: -8px;
      z-index: 2;
    }
    .rating-area:not(:checked) > input {
      display: none;
    }
    .rating-area:not(:checked) > label {
      float: right;
      width: 12px;
      padding: 0;
      cursor: pointer;
      font-size: 12px;
      line-height: 12px;
      content: url(../../assets/icons/star-grey.svg);
    }
    .rating-area:not(:checked) > label:before {
      content: url(../../assets/icons/star-orange.svg);
    }
    .rating-area > input:checked ~ label {
      content: url(../../assets/icons/star-orange.svg);
    }
    .rating-area:not(:checked) > label:hover,
    .rating-area:not(:checked) > label:hover ~ label {
      content: url(../../assets/icons/star-orange.svg);
    }
    .rating-area > input:checked + label:hover,
    .rating-area > input:checked + label:hover ~ label,
    .rating-area > input:checked ~ label:hover,
    .rating-area > input:checked ~ label:hover ~ label,
    .rating-area > label:hover ~ input:checked ~ label {
      content: url(../../assets/icons/star-orange.svg);
    }
    .rate-area > label:active {
      position: relative;
    }
  }

  .mcard{
    padding: 20px;
    margin-bottom: 1px;
    a{
      text-decoration-line: underline;
      color: #7A818F;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
    }
    &__top{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 10px;
      .title{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 40%;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #2CB181;
        img{
          margin-right: 10px;
          width: 30px;
          height: 30px;
          object-fit: cover;
          border-radius: 100%;
        }
      }
      .info{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        width: 40%;
        .rate{
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 25px;
          height: 12px;
        }
        .date{
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          display: flex;
          align-items: flex-end;
          text-align: right;
          color: #B6BCC8;
        }
      }
    }
    &__text{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #7A818F;
      margin-bottom: 12px;
    }
    &__reply{
      border-top: 1px solid #EEF0F3;;
      &-top{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin: 10px 0 10px 0;
        .title{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          width: 40%;
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          color: #2CB181;
          img{
            margin-right: 10px;
          }

        }
        .info{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-end;
          width: 40%;
          .date{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            display: flex;
            align-items: flex-end;
            text-align: right;
            color: #B6BCC8;
          }
        }
      }
    }
  }
  h4{
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #2D3137;
    margin-top: 26px;
  }
  .input{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    background: #EEF0F3;
    margin-bottom: 15px;
    input{
      width: 60%;
      height: 40px;
      margin: 0 0 0 0;
      background: #FFFFFF;
      border: 1px solid #EEF0F3;
      box-sizing: border-box;
      border-radius: 4px;
      padding-left: 15px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #7A818F;
    }
    .rate{
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;

    }
    button{
      width: 20%;
      height: 40px;
      margin: 0;
      background: #2CB181;
      border-radius: 4px;
      border: none;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
    }
  }

</style>
